var _mask, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoading = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_467_2111",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_467_2111_clip_path)",
    mask: "url(#path-1-inside-1_467_2111)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.012 0 0 0.012 12 12)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1250,
    y: -1250,
    width: 2500,
    height: 2500
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 0) 0deg,rgba(255, 255, 255, 0) 88.2692deg,rgba(255, 255, 255, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H21C21 16.9706 16.9706 21 12 21V24V27C20.2843 27 27 20.2843 27 12H24ZM12 24V21C7.02944 21 3 16.9706 3 12H0H-3C-3 20.2843 3.71573 27 12 27V24ZM0 12H3C3 7.02944 7.02944 3 12 3V0V-3C3.71573 -3 -3 3.71573 -3 12H0ZM12 0V3C16.9706 3 21 7.02944 21 12H24H27C27 3.71573 20.2843 -3 12 -3V0Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":0.24519230425357819},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":0.24519230425357819},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":24.0,\"m01\":1.5601262686251727e-13,\"m02\":-1.5454304502782179e-13,\"m10\":-5.7424822275803367e-14,\"m11\":24.0,\"m12\":5.5955240441107890e-14},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_467_2111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_467_2111_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12H21C21 16.9706 16.9706 21 12 21V24V27C20.2843 27 27 20.2843 27 12H24ZM12 24V21C7.02944 21 3 16.9706 3 12H0H-3C-3 20.2843 3.71573 27 12 27V24ZM0 12H3C3 7.02944 7.02944 3 12 3V0V-3C3.71573 -3 -3 3.71573 -3 12H0ZM12 0V3C16.9706 3 21 7.02944 21 12H24H27C27 3.71573 20.2843 -3 12 -3V0Z",
    mask: "url(#path-1-inside-1_467_2111)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading.e0b87bf78ec8c5510f47626b00ee8f31.svg";